import React from 'react';
import { ExchangeItem } from './ExchangeItem';
import { ExchangeHeader } from './ExchangeHeader';
import { useExchangeDelete } from '../services/useExchangeDelete';
import { useExchangeSubmit } from '../services/useExchangeSubmit';
import { useFormValues } from './hooks/useFormValues';

export const ExchangeList = ({ exchangeData, setExchangeData }) => {
  const { formValues, setFormValues } = useFormValues({ exchangeData });

  const { exchangeDeleteRequest } = useExchangeDelete();
  const { submitExchangeRequest, loading } = useExchangeSubmit();

  const isSubmitDisabled =
    formValues.entries.length === 0 ||
    !formValues.entries.every(entry => entry.reason && entry.reason.trim() !== '') ||
    loading;

  return (
    <>
      <ExchangeHeader orderNumber={exchangeData.originalOrderCode} />
      <div className="product-list">
        <h4>YOUR ITEMS</h4>
        {exchangeData.entries.map(exchangeItem => (
          <ExchangeItem {...exchangeItem} key={exchangeItem.originalOrderEntry.id} setFormValues={setFormValues} />
        ))}
        <div className="button-container">
          <p>
            You’ll be taken to the online store to find your replacement. Your credit will be added to the basket at
            checkout.
          </p>
          <button
            type="button"
            disabled={isSubmitDisabled}
            onClick={() => {
              submitExchangeRequest({ formValues });
            }}
          >
            Find a replacement
            {loading && <span className="button--animate icon-loop2" />}
          </button>
          <button
            className="cancel-exchange-btn"
            onClick={() => {
              exchangeDeleteRequest();
              setExchangeData(null);
            }}
            type="button"
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};
